

























































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { Location } from "vue-router";
import _ from "@/boot/lodash";

// Mixins
import Context from "@/mixins/context";

// Enums/Data
import { LogoSize, LogoType } from "@/data/enums/logos";
import { PurchaseTypes } from "@/data/enums/products";
import { ProductTypes } from "@/data/enums/products";

// Types
import {
  IProvisionCategory,
  IProvisionConfiguration,
  IProvisionProvider
} from "@/models/provisioning";
import { IProduct } from "@/models/products";

@Component({
  components: {
    "product-image": () =>
      import("@/components/app/global/products/productImage.vue")
  }
})
export default class ProductListItem extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public readonly product!: IProduct & {
    provision_category: IProvisionCategory | null;
    provision_configuration: IProvisionConfiguration | null;
    provision_provider: IProvisionProvider | null;
  };

  @Prop({ default: false })
  public readonly hasProvisioning!: boolean;

  @Prop({ default: "adminCatalogueProduct" })
  public readonly itemRouteName!: Location["name"];

  @Prop({ default: null })
  public selectedProducts!: {
    id: IProduct["id"];
    category_id: IProduct["category_id"];
  }[];

  @Prop({ default: null })
  public disabledProducts!: IProduct["id"][];

  @Prop({ default: false })
  public disableBundles!: boolean;

  @Prop({ default: true })
  public isMultiselect!: boolean;

  @Prop({ default: false })
  public isOpeningModal!: boolean;

  // Computed

  public get isSelected() {
    return (
      this.isSelect && _.some(this.selectedProducts, ["id", this.product.id])
    );
  }

  public get itemRoute() {
    return {
      name: this.itemRouteName,
      params: { productId: this.product.id }
    };
  }

  public get isInactive() {
    return !this.product.available_for_sales;
  }

  public get provCategoryName() {
    return _.get(this.product, "provision_category.name");
  }

  public get provProviderValue() {
    return _.compact([
      _.get(this.product, "provision_provider.name"),
      _.get(this.product, "provision_configuration.name")
    ]).join(" » ");
  }

  public get provProviderLogoUrl() {
    const logos = _.get(this.product, "provision_provider.logos", []);
    return this.$_.get(
      this.$_.find(logos, logo => {
        if (logo.type === LogoType.ICON && logo.size === LogoSize.ONE_X)
          return true;
        return false;
      }),
      "url",
      null
    );
  }

  public get isSelect() {
    return !_.isNil(this.selectedProducts);
  }

  public get isDisabled() {
    return (
      (!_.isNil(this.disabledProducts) &&
        this.disabledProducts.includes(this.product.id)) ||
      (this.disableBundles &&
        this.product.product_type === ProductTypes.PRODUCT_BUNDLE)
    );
  }

  public itemSelected(value) {
    if (this.isDisabled) return;
    this.$emit(
      "selectProduct",
      {
        id: this.product.id,
        category_id: this.product.category_id,
        name: this.product.name
      },
      value
    );
  }

  public itemClicked(value) {
    if (this.isDisabled) return;

    if (!this.isOpeningModal) {
      this.itemSelected(value);
      return;
    }

    this.$emit("openModal");
  }

  public get availableTerms() {
    return this.$tc(
      "_plurals.available_terms",
      _.uniqBy(this.product.prices, "billing_cycle_months").length
    );
  }

  public get paymentValue() {
    return this.product.billing_cycle_months === PurchaseTypes.RECURRING
      ? `${this.$t("_.recurring")} (${this.availableTerms})`
      : `${this.$t("_.one_off")}`;
  }
}
